
import { defineComponent } from '@nuxtjs/composition-api';
import mobileAppBannerMixin from '@/components/partials/war-room/WarRoomMobileAppBanner/mobileAppBannerMixin';
import { invalidRoutes } from '@/components/partials/war-room/WarRoomMobileAppBanner/constants';

const TOOLTIP_NAME = 'mobile-app-banner-top';

export default defineComponent({
  name: 'WarRoomMobileAppBannerTop',
  mixins: [mobileAppBannerMixin(TOOLTIP_NAME)],
  computed: {
    isValidRoute() {
      return !invalidRoutes.some(page => page.name === this.$route.name);
    },

    showBanner() {
      return [this.isVisible, this.$device.isMobile, this.$device.isIos, this.isValidRoute].every(Boolean);
    },
  },
});
